import React, { forwardRef } from "react";
import propTypes from "prop-types";
import cn from "classnames";
import styles from "./TableRow.module.scss";

const TableRow = forwardRef(({ className, component: Component, ...other }, ref) => {
  return <Component ref={ref} className={cn(styles.container, className)} {...other} />;
});

TableRow.displayName = "TableRow";

TableRow.defaultProps = {
  className: undefined,
  component: "tr"
};

TableRow.propTypes = {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: propTypes.node.isRequired,
  /**
   * @ignore
   */
  className: propTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: propTypes.elementType
};

export default TableRow;
